<template>
  <div>
    <v-btn-toggle
        v-model="vt.filter"
        color="primary"
    >
      <v-btn
          width="70px"
          small
          :value=true
          text>
        <v-icon>mdi-check</v-icon>
      </v-btn>
      <v-btn
          width="70px"
          small
          :value=false
          text>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: "TcnSwitch",
  props: ['vt'],
}
</script>

<style scoped>

</style>
